import AvailabilityInStoreProvider from './availability-in-store'
import ConfirmDialogProvider from './confirm-dialog/confirm-dialog'
import EssentialProviders from './essentials'
import FloatingActionsProvider from './floating-actions'
import HeaderProvider from './header'
import MenusProvider from './menus'
import MiniWishListProvider from './mini-wish-list'
import MiniCartProvider from './minicart'
import NewsletterProvider from './newsletter'
import NotifyMessageProvider from './notify-message'
import OosNotificationProvider from './oos-notification/oos-notification'
import QuickBuyProvider from './quick-buy/quick-buy'
import SearchProvider from './search'
import { UserActionsProvider, UserSourceProvider } from './user'
import { SalesAgentActionsProvider } from './sales-agent'
import { ParallaxProvider } from 'react-scroll-parallax'
import ChangeCountryLanguageProvider from './change-country-language/change-country-language'

const Providers = ({
	children,
	cookiesProps,
	store,
	currency,
	config,
	defaultTranslations,
	translations,
	locale,
	userAuthenticated,
	salesAgentAuthenticated,
	userGroup,
	salesAgentGroup,
	swrConfigProps,
	pageProps,
}) => (
	<EssentialProviders
		cookiesProps={cookiesProps}
		store={store}
		currency={currency}
		config={config}
		defaultTranslations={defaultTranslations}
		translations={translations}
		locale={locale}
		userAuthenticated={userAuthenticated}
		salesAgentAuthenticated={salesAgentAuthenticated}
		userGroup={userGroup}
		salesAgentGroup={salesAgentGroup}
		swrConfigProps={swrConfigProps}
		pageProps={pageProps}
	>
		<ParallaxProvider>
			<MenusProvider>
				<NotifyMessageProvider>
					<UserSourceProvider>
						<UserActionsProvider>
							<SalesAgentActionsProvider>
								<NewsletterProvider>
									<ConfirmDialogProvider>
										<AvailabilityInStoreProvider>
											<OosNotificationProvider>
												<QuickBuyProvider>
													<MiniCartProvider>
														<MiniWishListProvider>
															<SearchProvider>
																<ChangeCountryLanguageProvider>
																	<FloatingActionsProvider>
																		<HeaderProvider>{children}</HeaderProvider>
																	</FloatingActionsProvider>
																</ChangeCountryLanguageProvider>
															</SearchProvider>
														</MiniWishListProvider>
													</MiniCartProvider>
												</QuickBuyProvider>
											</OosNotificationProvider>
										</AvailabilityInStoreProvider>
									</ConfirmDialogProvider>
								</NewsletterProvider>
							</SalesAgentActionsProvider>
						</UserActionsProvider>
					</UserSourceProvider>
				</NotifyMessageProvider>
			</MenusProvider>
		</ParallaxProvider>
	</EssentialProviders>
)

export default Providers
